import { Component, HostListener, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TeamListComponent } from 'src/app/private/modules/components/teams/team-list/team-list.component';
import { TeamService } from 'src/app/private/services/teams.service';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-manage-teams',
  templateUrl: './manage-teams.component.html',
  styleUrls: ['./manage-teams.component.scss']
})
export class ManageTeamsComponent {
  mobileTeamListVisible: boolean = false;
  isRefresh = true;
  initalLoadGroup = true;
  allTeams: any[] = [];
  currentSelectedTeamId: any;
  formAction: string = '';
  teamToEdit: any;

  totalRows = 0;
  currentPage = 0;
  pageSize = 10;
  initialLoad = true;
  TeamsData: any[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  btnLoading = false;

  users : any[] = [];

  @ViewChild(TeamListComponent)  teamListComponent!: TeamListComponent;

  selectedUsers: any[] = [];



  constructor(
    private modalService: NgbModal,
    private toaster: ToastrService,
    private api: TeamService,
    private userApi: UsersService,
    private localStorage: LocalStorageService,
    private tracker: TrackingService
  ) { }

  toggleTeamList(){
    this.mobileTeamListVisible = !this.mobileTeamListVisible;
  }
  
  @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
      const target = event.target as HTMLElement;
      if (!target.closest('.left-box') && this.mobileTeamListVisible){
        this.mobileTeamListVisible = false;
      }
  }

  ngOnInit() {
    this.getAllTeams();
    this.getAllUsers();
  }

  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  getAllTeams() {
    const payload = { "client_id": this.localStorage.getClientId() };
    this.initalLoadGroup = true;
    this.api.getAllTeams(payload).subscribe(
      (res: any) => {
        this.allTeams = res;
        this.initalLoadGroup = false;
        this.currentSelectedTeamId = this.allTeams?.[0]?.team_id;
      },
      (err: any) => {
        console.error(err);
      }
    )
  }

  handleChangeTeam(event: any) {
    this.currentSelectedTeamId = event?.team_id ;
  }

  open(content: any) {
    this.formAction = 'Add';

    this.modalService
      .open(content, {
        size: 'lg', scrollable: true,
        centered: true, backdrop: 'static', keyboard: false
      })
  }

  openEditTeam(content: any, event: any) {
    this.modalService
      .open(content, { size: 'md', scrollable: true, centered: true })

    this.teamToEdit = event;
  }

  openDeleteTeam(content: any, event: any) {
    this.modalService
      .open(content, { size: 'md', scrollable: true, centered: true })

    this.teamToEdit = event;
  }

  addMembersToTeam(content: any) {
    this.modalService
      .open(content, { size: 'lg', scrollable: true, centered: true })
  }

  handleSetSelectedUsers(event: any) {
    this.selectedUsers = event;
  }

  relaodTable(){
    this.teamListComponent.reloadData();
  }

  reloadList() {
    this.getAllTeams();
  }

  handleDeleteEvent() {

    const payload = {
      "team_id": this.teamToEdit.team_id,
    }

    this.btnLoading = true;

    this.api.deleteTeam(payload).subscribe(
      (res: any) => {

        this.btnLoading = false;
        this.toaster.success(res.message || 'Team deleted successfully');
        this.tracker.track("Delete", "Team", `Deleted team with ID: ${this.teamToEdit.team_id}`);
        this.modalService.dismissAll();
        this.getAllTeams();
      },
      (err: any) => {
        this.btnLoading = false;
        this.toaster.error(err.error.message || 'Something went wrong');
        console.error(err);
      }
    )
  }

  handleChangeTeamName(name:any){
    this.allTeams = this.allTeams.map((team) => {
      if (team.team_id === this.teamToEdit.team_id) {
        return { ...team, name: name };
      }
      return team;
    }
    );
  }

}
